module.exports = __webpack_public_path__ + "assets/images/logo-share-facebook.png?9bb716fb54f2564ec05a98586b2ea16b";


//////////////////
// WEBPACK FOOTER
// ./_source/images/logo/logo-share-facebook.png
// module id = 604
// module chunks = 0